export const FILTER_DROPDOWN_ICON = '▾';

export function formatOptionLabel(value: string): string {
  return value
    .toLowerCase()
    .split(' ')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function formatCurrency(value: string | null | undefined): string {
  if (!value) return '--';

  const amount = Number(value);
  if (Number.isNaN(amount)) {
    return value;
  }

  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatPriceUnit(unit: string | null | undefined): string {
  if (!unit) return '';
  const cleaned = unit.trim();
  const normalized = cleaned.startsWith('/') ? cleaned.slice(1) : cleaned;
  return normalized.replace(/^PER_/i, '').toLowerCase().replace(/_/g, ' ');
}

export function formatDetailValue(value: unknown, formatString?: (value: string) => string): string {
  if (value === null || value === undefined || value === '') {
    return '--';
  }

  if (typeof value === 'string') {
    return formatString ? formatString(value) : value;
  }

  if (typeof value === 'object') {
    return JSON.stringify(value);
  }

  return String(value);
}
